import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IFilterPaginationDto, IItemGalleryDto } from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class GalleryService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getGalleryList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IItemGalleryDto[]> {
    return this.post(`admin/gallery/list/${id}`, model);
  }

  public changeGalleryStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/gallery/${id}`, null);
  }

  public saveGallery(
    model: IItemGalleryDto,
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/gallery`, model);
  }

  public deleteGallery(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/gallery/${id}`);
  }

  public updateSectionName(
    model: KeyValue<number, string>,
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/gallery/section`, model);
  }
}
